<div class="busy" *ngIf="busy" [ngClass]="{'busy-absolute': absolute}">
  <bari-animation animation="loading_bouncing_preto_big" [loop]="true" [width]="120"></bari-animation>
</div>
